export function shuffleArray<T>(array: T[]): void {
  for (let index = array.length - 1; index > 0; index--) {
    const index_ = Math.floor(Math.random() * (index + 1));
    const temporary = array[index];
    array[index] = array[index_] as T;
    array[index_] = temporary as T;
  }
}
